module.exports = __webpack_public_path__ + "fonts/ruble-42a7cf33bd31f0c717b534fc9a22801a.woff";


//////////////////
// WEBPACK FOOTER
// ./src/shared/fonts/ruble.woff
// module id = 582
// module chunks = business-manager/video-library-page full-screen-modals/full-screen-modals mobile-overlay/mobile-overlay mobile/mobile widget/widget dashboard/dashboard app-settings/app-settings